var _circle, _g, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFace4Active(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 45,
    r: 43.31,
    fill: "#8bc73c"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 59.9,
    cy: 35.01,
    r: 6.3,
    opacity: 0.5,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.41,
    cy: 35.01,
    r: 6.31,
    opacity: 0.5,
    style: {
      isolation: "isolate"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.74,54.59A2.13,2.13,0,0,1,62,58.47a33,33,0,0,1-10.57,4.39A28.74,28.74,0,0,1,28,58.47,2.13,2.13,0,0,1,30.46,55a24.65,24.65,0,0,0,10.65,4.22,25.66,25.66,0,0,0,9.32-.48A29.37,29.37,0,0,0,59.54,55,2.06,2.06,0,0,1,60.74,54.59Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.24,12.17a43.3,43.3,0,0,1-62.73,59,43.31,43.31,0,0,0,69-52.38,42.72,42.72,0,0,0-6.25-6.64Z",
    fill: "#7cb337"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFace4Active);
export default __webpack_public_path__ + "static/media/face_4_active.f03e3db8.svg";
export { ForwardRef as ReactComponent };